/**
 * Typed, frozen accessor over `import.meta.env`. Throws at boot if a required
 * variable is missing so a mis-provisioned terminal fails loudly instead of
 * silently pointing at the wrong backend.
 */

function required(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`[env] Missing required environment variable: ${key}`);
  }
  return value;
}

function optional(key: keyof ImportMetaEnv, fallback: string): string {
  return import.meta.env[key] ?? fallback;
}

export const env = Object.freeze({
  API_URL: required('VITE_API_URL'),
  SOCKET_URL: optional('VITE_SOCKET_URL', 'http://localhost:9224'),
  BRAND_NAME: optional('VITE_BRAND_NAME', 'Autopia'),
  TIMEZONE: optional('VITE_TIMEZONE', 'Asia/Jakarta'),
  MIDTRANS_CLIENT_KEY: optional('VITE_MIDTRANS_CLIENT_KEY', ''),
  MIDTRANS_SNAP_URL: optional(
    'VITE_MIDTRANS_SNAP_URL',
    'https://app.sandbox.midtrans.com/snap/snap.js',
  ),
  CASHLESS_READER_MID: optional('VITE_CASHLESS_READER_MID', ''),
  CASHLESS_READER_TID: optional('VITE_CASHLESS_READER_TID', ''),
  ENABLE_FACE: optional('VITE_ENABLE_FACE', 'false') === 'true',
});

export type Env = typeof env;
